import React from 'react';
// There is an import cycle in the page content templates.
// If you import the templates early, it can be resolved by the time you really need things to be working.
// If you so much as swap the next two lines, the app will break and show old inputs, and tests will fail.
// This line didn't use to exist because it already ended up happening by other imports.
// Adding this line here helps with the ability to import <Page /> from other places where the templates haven't already been imported by anything else (and so the import cycle has not yet been resolved)
import 'Views/Page/Content/Templates';
import ErrorBoundary from 'Errors/ErrorBoundary';
import PropTypes from 'prop-types';
import { ModalProvider } from 'Views/Page/Contexts/ModalContext';
import AnnouncementDialog from 'Context/AnnouncementContext/Dialog';
import PageContainer from './PageContainer';
import { PageContentProvider } from './Contexts/PageContentContext';

const Page = ({ showAnnouncements, navigationHeaderLeft, navigationHeaderRight }) => {
  return (
    <ErrorBoundary>
      <PageContentProvider>
        <ModalProvider>
          <PageContainer
            navigationHeaderLeft={navigationHeaderLeft}
            navigationHeaderRight={navigationHeaderRight}
          />
          {showAnnouncements ? <AnnouncementDialog /> : null}
        </ModalProvider>
      </PageContentProvider>
    </ErrorBoundary>
  );
};
Page.propTypes = {
  navigationHeaderLeft: PropTypes.object,
  navigationHeaderRight: PropTypes.object,
  showAnnouncements: PropTypes.bool,
};
Page.defaultProps = {
  navigationHeaderLeft: undefined,
  navigationHeaderRight: undefined,
  showAnnouncements: false,
};

export default Page;
